import { i18n } from '@/i18n.js';


const NAME_REGEXP = /^(\p{L}|-)+$/u;
const PHONE_REGEXP = /^[0-9-()\s+]*$/;
const PHONE_NUMBER_N_PLUS_REGEXP = /^[0-9+]*$/;
const NUMBER_REGEXP = /^[0-9]*$/;
const INN_REGEXP = /^\d{10}$|^\d{12}$/;
const EMAIL_REGEXP = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;


/**
 * Get string message instead thowing error
 * Example: `message = getMessage(phoneValidator, this.user.phone);`
 * @param {*} fun function validator
 * @param {*} value should be validated
 * @returns message or nothing
 */
export function getMessage(fun, value) {
	try {
		fun(value);
	} catch (message) {
		return message;
	}
}

export function nameAndLastNameValidator(value) {
	if (!NAME_REGEXP.test(value)) {
		throw i18n.t('users.verify_first_and_last_name');
	}
}

export function phoneValidator(value) {
	if (!PHONE_REGEXP.test(value)) {
		throw i18n.t('users.verify_phone');
	}
}

export function phoneValidatorNumbersAndPlus(value) {
	if (!PHONE_NUMBER_N_PLUS_REGEXP.test(value)) {
		throw i18n.t('users.verify_phone_only_number_and_plus');
	}
}

export function numbersValidator(value) {
	if (!NUMBER_REGEXP.test(value)) {
		throw i18n.t('users.only_numbers');
	}
}

export function innValidator(value) {
	if (!INN_REGEXP.test(value)) {
		throw i18n.t('users.verify_inn');
	}
}

export function emailValidator(value) {
	if (!EMAIL_REGEXP.test(value)) {
		throw i18n.t('errors.invalid_email');
	}
}
